module.exports = __webpack_public_path__ + "static/media/apple_pencil_light.dfff295c.svg";